






















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import { STORE_KEY, store } from './_store';

import TitleBar from '@/components/Elements/TitleBar.vue'

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      'loading', 'loaded', 'fatalError',

      'filter',

      'lastMeta', 'notifications',
    ]),
  },
  components: {
    TitleBar
  }
})
export default class Notifications extends Vue {

  get titleStack () {
    return [
      'Уведомления'
    ]
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    this.$store.dispatch(`${STORE_KEY}/reset`);
    this.handleParamsChange();
  }

  public loadingMore = false;
  public loadMore() {
    this.loadingMore = true;

    this.$store.dispatch(`${STORE_KEY}/loadMore`)
      .finally(() => {
        this.loadingMore = false;
      })
  }

  // ---------------------------------------------------------------------------
  // getColor(item: any) {
  //   return item.is_read ? 'transparent' : 'lightgoldenrodyellow';
  // }

  markAsRead(item: any) {
    this.$store.dispatch(`${STORE_KEY}/markNotificationAsRead`, item.id);
  }

  markAllAsRead() {
    this.$store.dispatch(`${STORE_KEY}/markNotificationAsRead`, null);
  }

  public handleParamsChange() {
    this.$store.dispatch(`${STORE_KEY}/loadData`);
  }

  public refreshData($event: any) {
    this.$store.dispatch(`${STORE_KEY}/loadData`)
      .finally(() => {
        $event.detail.complete();
      });
  }
}
